<ng-container [formGroup]="indicativoForm">
    <mat-select [formControlName]="nombreCampo">
        <mat-select-trigger>
            {{indicative.value}}
        </mat-select-trigger>
        <mat-option *ngFor="let indicativo of indicativos;" [value]="indicativo.indicativo">
            <div class="contenedor-indicativo">
                <span class="pais">
                    {{indicativo.pais}}
                </span>
                <span class="indicativo">
                    ({{indicativo.indicativo}})
                </span>
            </div>
        </mat-option>
    </mat-select>
</ng-container>